import * as activationStatusTypes from '../../consts/gam/activationStatusTypes';

export const gamAssetMapping = (data, isHolder) => {
    const yapActivationStatus = data.device?.yapActivationStatus?.toLowerCase();

    return {
        assetId: data.assetId,
        yapActivated:
            yapActivationStatus === activationStatusTypes.GAM_ACTIVATED ||
            yapActivationStatus === activationStatusTypes.GAM_ACTIVE,
        material: data.material,
        isHolder: !!isHolder,
    };
};
